/**
 * Created by tomers on 3/3/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Media = require("media");
    var template = require("personalization-web-agent-templates/away-reasons/awayReasonItem.tmpl");

    var AwayReasonItemView = {};

    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

        AwayReasonItemView = Marionette.ItemView.extend({
            template: template,
            className: "away-reason-container",
            ui: {
                icon: ".away-reason-icon",
                text: ".away-reason-text",
                edit: ".away-reason-edit",
                delete: ".away-reason-delete"
            },

            events: {
                "click": "_onEditClick",
                "click @ui.edit": "_onEditClick",
                "click @ui.delete": "_onDeleteClick"
            },

            modelEvents: {
                "change:text": "_updateText"
            },

            initialize: function(options) {
                return this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            onInvalid: function(model, errors) {
                this._onInvalid(model, errors);
            },
            setFocus: function() {
                this._setFocus();
            },


            _initialize: function (options) {
                this.channel = Media.channel(LE.mediaCodes.personalization.channels.AWAY_REASONS);
                this.model = options.model;
                this.container = options.container;
            },

            _onRender: function() {
                if (this.container) {
                    this.container.append(this.$el);
                }

                this._updateText();

            },

            _updateText: function() {
                var title = this.model.getText();
                this.ui.text.text(title);
                this.ui.text.attr("title", title);
            },

            _onEditClick: function(e) {
                e.stopPropagation();
                this.channel.trigger("awayReasons:list:edit", this.model);
            },

            _onDeleteClick: function(e) {
                e.stopPropagation();
                this.channel.trigger("awayReasons:list:delete", this.model);
            }
        });
    }

    LE.module("LEPersonalization", moduleDefinition);

    return AwayReasonItemView;

});
